import _toConsumableArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "disabled", "onChange"];
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import React__default from 'react';
import CheckboxOrRadioGroupCaption from '../internal/components/CheckboxOrRadioGroup/CheckboxOrRadioGroupCaption.js';
import CheckboxOrRadioGroupLabel from '../internal/components/CheckboxOrRadioGroup/CheckboxOrRadioGroupLabel.js';
import CheckboxOrRadioGroupValidation from '../internal/components/CheckboxOrRadioGroup/CheckboxOrRadioGroupValidation.js';
import Checkbox from '../Checkbox/Checkbox.js';
import { CheckboxGroupContext } from './CheckboxGroupContext.js';
import FormControl from '../FormControl/FormControl.js';
import { useRenderForcingRef } from '../hooks/useRenderForcingRef.js';
import CheckboxOrRadioGroup from '../internal/components/CheckboxOrRadioGroup/CheckboxOrRadioGroup.js';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var CheckboxGroup = function CheckboxGroup(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var formControlComponentChildren = React__default.Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) && child.type === FormControl;
  }).map(function (formControlComponent) {
    return /*#__PURE__*/React__default.isValidElement(formControlComponent) ? formControlComponent.props.children : [];
  }).flat();
  var checkedCheckboxes = React__default.Children.toArray(formControlComponentChildren).filter(function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) && child.type === Checkbox;
  }).map(function (checkbox) {
    return /*#__PURE__*/React__default.isValidElement(checkbox) && (checkbox.props.checked || checkbox.props.defaultChecked) && checkbox.props.value;
  }).filter(Boolean);

  var _useRenderForcingRef = useRenderForcingRef(checkedCheckboxes),
      _useRenderForcingRef2 = _slicedToArray(_useRenderForcingRef, 2),
      selectedCheckboxValues = _useRenderForcingRef2[0],
      setSelectedCheckboxValues = _useRenderForcingRef2[1];

  var updateSelectedCheckboxes = function updateSelectedCheckboxes(e) {
    var _e$currentTarget = e.currentTarget,
        value = _e$currentTarget.value,
        checked = _e$currentTarget.checked;

    if (checked) {
      setSelectedCheckboxValues([].concat(_toConsumableArray(selectedCheckboxValues.current || []), [value]));
      return;
    }

    setSelectedCheckboxValues((selectedCheckboxValues.current || []).filter(function (selectedValue) {
      return selectedValue !== value;
    }));
  };

  return /*#__PURE__*/React__default.createElement(CheckboxGroupContext.Provider, {
    value: {
      disabled: disabled,
      onChange: function onChange(e) {
        if (_onChange) {
          updateSelectedCheckboxes(e);

          _onChange(selectedCheckboxValues.current || [], e);
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(CheckboxOrRadioGroup, _extends({
    disabled: disabled
  }, rest), children));
};

CheckboxGroup.displayName = "CheckboxGroup";
var CheckboxGroup$1 = Object.assign(CheckboxGroup, {
  Caption: CheckboxOrRadioGroupCaption,
  Label: CheckboxOrRadioGroupLabel,
  Validation: CheckboxOrRadioGroupValidation
});
export { CheckboxGroupContext, CheckboxGroup$1 as default };